import React from "react";

const HomeFill = props => (
  <svg viewBox="0 0 24 19" fill="none" {...props}>
    <path
      d="M11.688 5.32L4.5 11.258v6.367c0 .352.273.625.625.625H9.5c.313 0 .586-.273.586-.625v-3.75c0-.313.312-.625.625-.625h2.5c.351 0 .625.313.625.625v3.75c0 .352.312.625.625.625h4.414a.642.642 0 00.625-.625v-6.406L12.273 5.32A.422.422 0 0012 5.203a.444.444 0 00-.313.117zm11.367 4.024l-3.242-2.696v-5.39a.475.475 0 00-.47-.469h-2.187a.451.451 0 00-.468.469V4.07l-3.516-2.89a2.008 2.008 0 00-2.383 0L.906 9.344a.466.466 0 00-.195.351c0 .117.078.235.117.313l1.016 1.21c.078.118.195.157.351.157.118 0 .235-.04.313-.117l9.18-7.54A.443.443 0 0112 3.603c.078 0 .195.039.273.117l9.18 7.539a.444.444 0 00.313.117c.156 0 .273-.04.351-.156l1.016-1.211a.444.444 0 00.117-.313.466.466 0 00-.195-.351z"
      fill="currentColor"
    />
  </svg>
);

export default HomeFill;
